import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onScrollToSection: (section: string) => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onScrollToSection }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-peaceful-teal to-healing-blue py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-peaceful-teal rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-primary rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-8">
            <Icon name="NewspaperIcon" size={24} className="text-white" />
            <span className="text-white font-cta text-sm font-bold">
              Media & Press Resources
            </span>
          </div>

          <h1 className="text-4xl lg:text-6xl font-headline font-bold text-white mb-6 leading-tight">
            Share the Story of Global Peace
          </h1>

          <p className="text-xl lg:text-2xl text-white/90 mb-12 leading-relaxed font-body">
            Access comprehensive media resources, press materials, and campaign assets to amplify the message of compassion and transformation worldwide.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => onScrollToSection('press-kit')}
              className="w-full sm:w-auto px-8 py-4 bg-white text-primary rounded-lg font-cta text-base font-bold transition-all duration-300 hover:scale-105 hover:shadow-xl flex items-center justify-center space-x-2"
            >
              <Icon name="ArrowDownTrayIcon" size={20} />
              <span>Download Press Kit</span>
            </button>

            <button
              onClick={() => onScrollToSection('media-contact')}
              className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-cta text-base font-bold transition-all duration-300 hover:bg-white hover:text-primary flex items-center justify-center space-x-2"
            >
              <Icon name="EnvelopeIcon" size={20} />
              <span>Media Inquiries</span>
            </button>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: 'DocumentTextIcon', label: 'Press Releases', count: '8' },
            { icon: 'PhotoIcon', label: 'Media Assets', count: '45+' },
            { icon: 'VideoCameraIcon', label: 'Video Content', count: '12' },
            { icon: 'MicrophoneIcon', label: 'Interviews', count: '18' },
          ].map((stat, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center transition-all duration-300 hover:bg-white/20"
            >
              <Icon name={stat.icon as any} size={32} className="text-white mx-auto mb-3" />
              <div className="text-3xl font-headline font-bold text-white mb-1">
                {stat.count}
              </div>
              <div className="text-sm text-white/80 font-body">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;